export const checkIfNewUnitSelected = (selectedToken) => {
  return !!selectedToken && selectedToken.startsWith('unit_');
}